export default {
  props: {
    // 是否为密级文件
    // isFileEncrypt: {
    //   type: Boolean,
    //   default: false,
    // },
    // 密级文件修改范围
    // encryptfileModifyrange: {
    //   type: String,
    //   default: "notModifiable",
    // },
    // 密级字段是否为必填
    // encryptfileRequire: {
    //   type: Boolean,
    //   default: false,
    // },
    // 密级文件截止时间是否可修改
    editEncryptfileDeadline: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.$eventBus.$on("changeFormEncryptLevel", this.formEncryptLevelChange);
  },

  computed: {
    // 是否设置为密级控件
    isFileEncrypt() {
      return dsf.config.setting_security_is_open_classified == "1";
    },
    // 密级选项
    securityLevel() {
      if (!this.isFileEncrypt) {
        return [];
      }
      let securityLevel =
        this.$vm.$viewInitData?.[this.metadata.dataKey]?.dataSource || [];
      if (dsf.isArray(securityLevel) && securityLevel.length > 0)
        return _.filter(securityLevel, (item) => {
          // 未选择表单密级值
          if (this.formEncryptLevel === "") {
            return false;
          } else if (this.formEncryptLevel === null) {
            // 无表单密级组件
            return true;
          } else {
            // 根据表单密集组件值过滤选项
            return item.value <= this.formEncryptLevel;
          }
        });
      return [];
    },
    // 密级选项Map形式
    $securityLevelMap() {
      let mapping = {};
      _.forEach(this.securityLevel, (item) => {
        mapping[item.value] = item.text;
      });
      return mapping;
    },
  },

  data() {
    return {
      // 缓存密级过期时间
      securityLevelExpiryDateObj: {},
      // null：页面没有表单密级组件, "": 页面有表单密级但没有选值; 否则为表单密级组件值
      formEncryptLevel: null,
    };
  },
  methods: {
    // 根据当前页面的表单密级组件值，筛选当前组件密级等级
    formEncryptLevelChange(level) {
      this.formEncryptLevel = level;
      if (this.isFileEncrypt && level) {
        let changedItmes = [];
        let queryExpiryDates = [];
        _.forEach(this.multipleFiles || [], (item) => {
          if (item.isNew) {
            // 如果当前选择的密级大于表单密级则需要降低该密级等级
            if (item.securityLevelValue > level) {
              let validLevels = [];
              _.forEach(this.securityLevel, ({ value }) => {
                if (value <= level) {
                  validLevels.push(value);
                }
              });
              const maxLevel = Math.max.apply(null, validLevels) + "";
              if (maxLevel) {
                item.securityLevelValue = maxLevel;
                item.securityLevelText = this.$securityLevelMap[maxLevel];
                changedItmes.push({
                  dmId: item.id,
                  securityLevelValue: item.securityLevelValue,
                  securityLevelText: item.securityLevelText,
                });
                queryExpiryDates.push(
                  this.getExpiryDate(item.securityLevelValue)
                );
              }
            } else if (item.securityLevelValue === "") {
              // 如果当前上文文件列表没有选择密级等级，则默认选上第一个
              const { text, value } = this.securityLevel[0] || {};
              if (text || value) {
                item.securityLevelValue = value;
                item.securityLevelText = text;
                changedItmes.push({
                  dmId: item.id,
                  securityLevelValue: item.securityLevelValue,
                  securityLevelText: item.securityLevelText,
                });
                queryExpiryDates.push(this.getExpiryDate(value));
              }
            }
          }
        });
        // 若因页面表单密级改动而影响的上传文件, 需要通知后端
        if (queryExpiryDates.length) {
          Promise.all(queryExpiryDates).done((res) => {
            let expiryDateMap = {};
            _.forEach(res, (item, index) => {
              const { dmId } = changedItmes[index];
              expiryDateMap[dmId] = item;
              changedItmes[index].securityLevelExpiryDate = item;
            });
            this.$http
              .post("/file/batchUpdateFileSecret", changedItmes, {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                },
              })
              .then(({ data }) => {
                let { success, message } = data;
                if (!success) {
                  dsf.layer.message(message || "请求异常", false);
                } else {
                  _.forEach(this.multipleFiles, (item) => {
                    if (expiryDateMap[item.id] !== undefined) {
                      item.securityLevelExpiryDate = expiryDateMap[item.id];
                    }
                  });
                  this.updateValue(this.multipleFiles);
                }
              });
          });
        }
      }
    },
    // 获取过期时间
    async getExpiryDate(securityLevelValue) {
      if (this.securityLevelExpiryDateObj?.[securityLevelValue] != undefined) {
        return this.securityLevelExpiryDateObj[securityLevelValue];
      }

      let result = "";
      await this.$http
        .get("/setting/getDefaultExpiryDate", {
          secretLevel: securityLevelValue,
        })
        .then(({ data }) => {
          if (dsf.isString(data.data) && data.data) {
            result = data.data;
            this.securityLevelExpiryDateObj[securityLevelValue] = result;
          } else {
            this.securityLevelExpiryDateObj[securityLevelValue] = "";
          }
        });
      return result;
    },
  },
  beforeDestroy() {
    this.$eventBus.$off("changeFormEncryptLevel", this.formEncryptLevelChange);
  },
};
